import CompactPill from 'v2/components/CompactPill';
import StatusPillLabel from 'v2/components/text/StatusPillLabel';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ExpiredPill: FunctionComponent<Props> = ({ className = '', testId = TEST_ID, text }) => (
    <CompactPill className={`${styles.expiredPill} ${className}`} testId={testId}>
        <StatusPillLabel text={text} />
    </CompactPill>
);

export default ExpiredPill;
